import * as React from 'react';
import { Tooltip } from '@mui/material';

interface NavTooltipProps {
  /** Row label — also becomes the accessible name while the drawer is collapsed. */
  label: string;
  isOpen: boolean;
  children: React.ReactElement;
}

/**
 * Hover label for the collapsed sidebar. When the drawer is open the row already
 * renders its text, so the tooltip is skipped entirely — wrapping it anyway would
 * duplicate the visible label and stamp an empty `aria-label` on the row.
 */
const NavTooltip: React.FC<NavTooltipProps> = ({ label, isOpen, children }) => {
  if (isOpen) return children;

  return (
    <Tooltip title={label} placement="right">
      {children}
    </Tooltip>
  );
};

export default NavTooltip;
